export const reportEndpoints = (builder) => ({
    getReports: builder.query({
        query: () => ({url: `/admins/reports`, method: 'get'}),
        providesTags: ['Reports'],
    }),
    generateDownloadURL: builder.mutation({
        query: (id) => ({url: `/admins/report/${id}`, method: 'post'}),
    }),
})